export default "__VITE_ASSET__DX$KImq3__"